export interface Deferred<T> {
  promise: Promise<T>;
  resolve: (value: T) => void;
}

export function defer<T = void>(): Deferred<T> {
  let resolveFn!: (value: T) => void;
  const promise = new Promise<T>((resolve) => {
    resolveFn = resolve;
  });
  return { promise, resolve: resolveFn };
}
